import styled from "styled-components";

export const Card = styled.div`
    height: auto;
    min-height: 30px;
    width: auto;
    min-width: 50px;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
`;